<template>
  <div class="l-block__content">
    <Loading v-if="isLoading" />
    <template v-if="!isLoading">
      <div class="l-block__nav">
        <div
          class="l-block__nav--item"
          @click="changeStep('findKeyword')"
          :class="{ selected: step === 'findKeyword' }"
        >
          <span>1.対策キーワードを探す</span>
        </div>
        <div
          class="l-block__nav--item"
          @click="changeStep('makeHeadline')"
          :class="{ selected: step === 'makeHeadline' }"
        >
          <span>2.記事構成案を作成する</span>
          <Label v-if="tasksCountNewContentTodo" variant="count">{{
            tasksCountNewContentTodo
          }}</Label>
        </div>
        <div
          class="l-block__nav--item"
          @click="changeStep('writing')"
          :class="{ selected: step === 'writing' }"
        >
          <span>3.執筆する</span>
          <Label v-if="tasksCountNewContentDoing" variant="count">{{
            tasksCountNewContentDoing
          }}</Label>
        </div>
      </div>

      <template v-if="step === 'findKeyword'">
        <NewContentFindKeyword />
      </template>

      <template v-if="step === 'makeHeadline'">
        <NewContentMakeHeadline
          :tasks="tasksNewContentTodo"
          :tasksCount="tasksCountNewContentTodo"
          :isLoading="isLoading"
        />
      </template>
      <template v-if="step === 'writing'">
        <NewContentWriting
          :project="project"
          :tasks="tasksNewContentDoing"
          :tasksCount="tasksCountNewContentDoing"
          @completeTask="completeTask"
          :isLoading="isLoading"
        />
      </template>
    </template>
  </div>
</template>

<script>
import Loading from '@/components/Loading';
import Label from '@/components/Label';
import NewContentFindKeyword from '@/components/dashboard/NewContentFindKeyword';
import NewContentMakeHeadline from '@/components/dashboard/NewContentMakeHeadline';
import NewContentWriting from '@/components/dashboard/NewContentWriting';

export default {
  props: {
    project: {
      type: Object,
      required: true
    },
    tasks: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      selectedStep: ''
    };
  },
  components: {
    Loading,
    NewContentFindKeyword,
    NewContentMakeHeadline,
    NewContentWriting,
    Label
  },

  computed: {
    tasksNewContentTodo() {
      return this.tasks.filter(v => {
        return v.column === 'todo';
      });
    },
    tasksCountNewContentTodo() {
      return this.tasksNewContentTodo.length;
    },
    tasksNewContentDoing() {
      return this.tasks.filter(v => {
        return v.column === 'doing';
      });
    },
    tasksCountNewContentDoing() {
      return this.tasksNewContentDoing.length;
    },
    step() {
      //ユーザーが自分でstepを変更した場合はそちらを優先する
      if (this.selectedStep) return this.selectedStep;

      //初期表示時はタスクの状況によって表示を変える
      if (this.tasksCountNewContentTodo == 0) {
        return 'findKeyword';
      } else {
        return 'makeHeadline';
      }
    }
  },

  methods: {
    completeTask(task) {
      this.$emit('completeTask', task);
    },
    changeStep(value) {
      this.selectedStep = value;
    }
  }
};
</script>
